import React from "react";
import "./NodeSphereIcon.css"; // Make sure this file exists!
import { TbSphere } from "react-icons/tb";

const NodeSphereIcon = () => (
  <svg
    className="node-sphere"
    width="40"
    height="40"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="45" stroke="#3B82F6" strokeWidth="3" />
    <circle cx="20" cy="30" r="3" fill="#3B82F6" />
    <circle cx="80" cy="30" r="3" fill="#3B82F6" />
    <circle cx="30" cy="70" r="3" fill="#3B82F6" />
    <circle cx="70" cy="70" r="3" fill="#3B82F6" />
    <circle cx="50" cy="20" r="3" fill="#3B82F6" />
    <circle cx="50" cy="80" r="3" fill="#3B82F6" />
    <circle cx="50" cy="50" r="3" fill="#1E40AF" />
    <line x1="20" y1="30" x2="50" y2="20" stroke="#60A5FA" strokeWidth="1.5" />
    <line x1="80" y1="30" x2="50" y2="20" stroke="#60A5FA" strokeWidth="1.5" />
    <line x1="30" y1="70" x2="50" y2="80" stroke="#60A5FA" strokeWidth="1.5" />
    <line x1="70" y1="70" x2="50" y2="80" stroke="#60A5FA" strokeWidth="1.5" />
    <line x1="20" y1="30" x2="30" y2="70" stroke="#60A5FA" strokeWidth="1.5" />
    <line x1="80" y1="30" x2="70" y2="70" stroke="#60A5FA" strokeWidth="1.5" />
    <line x1="50" y1="20" x2="50" y2="80" stroke="#60A5FA" strokeWidth="1.5" />
  </svg>
);

export default NodeSphereIcon;
